import React from 'react';
import { PATHS } from '@constants';
import { Link } from 'react-router-dom';
import ConditionalRenderer, { Else, If } from '@components/ConditionalRenderer';
import logo from 'assets/img/logo.svg';
import './style.scss';

const Logo = ({ onClick, coreElement }) => (
  <div className='main-logo' onClick={onClick}>
    <ConditionalRenderer condition={!coreElement}>
      <If>
        <Link to={PATHS.HOME}>
          <img width={117} height={32} src={logo} alt='Vann' />
        </Link>
      </If>
      <Else>
        <div>
          <img width={117} height={32} src={logo} alt='Vann' />
        </div>
      </Else>
    </ConditionalRenderer>
  </div>
);

export default Logo;
